import React from 'react';
import Documentation from './documentation';

function App() {
  return <Documentation />;
}

export default App;
